import apiClient from '../apiClient';

class ApplicationService {
  constructor(profile) {
    this.profile = profile;
  }

  toBackendFormat(data) {
    if (!data.jobId) {
      throw new Error('Job ID is required to create an application');
    }
    const { id, ...rest } = data;
    return {
      status: 'pending',
      ...rest,
    };
  }

  fromBackendFormat(doc) {
    if (!doc) return null;
    return doc;
  }

  async createApplication(data) {
    const backendData = this.toBackendFormat(data);
    const response = await apiClient.post('/applications', backendData);
    return this.fromBackendFormat(response);
  }

  async getApplicationsByJobId(jobId) {
    const response = await apiClient.get(`/applications/job/${jobId}`);
    return response.map(doc => this.fromBackendFormat(doc));
  }

  async getApplicationsByJobSeekerProfileId(jobSeekerProfileId) {
    const response = await apiClient.get('/applications/mine');
    return response.map(doc => this.fromBackendFormat(doc));
  }

  async hasUserAppliedForJob(jobId, jobSeekerProfileId) {
    try {
      const response = await apiClient.get(`/applications/check/${jobId}`);
      return response.hasApplied;
    } catch (error) {
      console.error('Error checking application status:', error);
      return false;
    }
  }
}

export default ApplicationService;